<template>
	<div class="white pos-rel rounded-lg">
		<div class="header">
			<div>
				{{
					!searchedUser
						? "Transfering Credit"
						: "Payment Acknowledgement"
				}}
			</div>
		</div>
		<v-btn
			fab
			flat
			class="top-right-align pa-0 ma-0 pt-1"
			@click="closeModal"
		>
			<v-icon>close</v-icon>
		</v-btn>
		<div class="pa-4" v-if="!searchedUser">
			<v-layout class="mb-2">
				<v-flex xs12 md4 lg3>
					Current Account Balance: {{ jeet11WalletBalance }}
				</v-flex>
			</v-layout>
			<v-layout class="mb-2">
				<v-flex xs12 md4 lg3 class="text-field-wrapper">
					<v-text-field
						label="Phone Number"
						prepend-icon="phone"
						v-model="phone"
						placeholder="Enter Phone Number"
						:rules="[requiredRule, onlyDigitRule]"
						maxlength="10"
						:disabled="Boolean(prefetchedRetailerPhoneNo)"
					></v-text-field>
				</v-flex>
			</v-layout>
			<div
				v-if="
					!isUserSettingsError &&
						!isUserSettingsLoading &&
						`${phone}`.length === 10
				"
			>
				<div style="display:flex">
					Unique Device:
					<v-icon
						:color="
							!!userSettingsData.userData[
								isRummyOptionSelected
									? 'isCardGameGenuineUser'
									: 'isFantasyGenuineUser'
							]
								? 'green'
								: 'red'
						"
					>
						{{
							!!userSettingsData.userData[
								isRummyOptionSelected
									? "isCardGameGenuineUser"
									: "isFantasyGenuineUser"
							]
								? "check_circle"
								: "cancel"
						}}
					</v-icon>
				</div>
				<div style="display:flex">
					Mapped to me (for online benefit):
					<v-icon
						:color="
							!!userSettingsData.isOnboarding ? 'green' : 'red'
						"
					>
						{{
							!!userSettingsData.isOnboarding
								? "check_circle"
								: "cancel"
						}}
					</v-icon>
				</div>
			</div>
			<v-layout class="mt-2">
				<v-flex xs12 md4 lg3 class="text-field-wrapper">
					<v-text-field
						label="Credit"
						v-model="amount"
						placeholder="Enter amount"
						prepend-icon="account_balance_wallet"
						:rules="[
							requiredRule,
							onlyDigitRule,
							isValueAllowedRules
						]"
						@keyup.enter="onSearchClick"
						maxlength="6"
						:disabled="Boolean(prefetchedAmount)"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs12 md4 lg3 class="mt-4">
					<v-btn
						class="ma-0 pa-4 white--text full-width btn"
						:color="themeInputColor"
						:disabled="
							(!prefetchedAmount &&
								(!amount ||
									!phone ||
									/\D/g.test(amount) ||
									/\D/g.test(phone) ||
									amount < 10)) ||
								(phone && phone.length !== 10) ||
								amount > jeet11WalletBalance
						"
						:loading="searchingJeet11User"
						@click="onSearchClick"
						>Transfer Credits</v-btn
					>
				</v-flex>
			</v-layout>
		</div>
		<div class="pa-4" v-else>
			<v-layout wrap class="mb-4">
				<v-flex class="mr-5" xs12 md4 lg4>
					<div class="caption text--disabled">Mobile Number</div>
					<strong class="headline blue-grey--text text--darken-1">{{
						phone
					}}</strong>
				</v-flex>
				<v-flex xs12 md4 lg3>
					<div class="caption text--disabled">TeamName</div>
					<strong class="headline light-blue--text text--darken-4">{{
						searchedUser.teamName
					}}</strong>
				</v-flex>
			</v-layout>
			<v-layout class="mb-4">
				<v-flex xs12 md4>
					<div class="caption text--disabled">Amount</div>
					<strong class="headline green--text text--dark-1">
						<span>&#8377;</span>
						{{ amount }}/-
					</strong>
				</v-flex>
				<v-flex>
					<img
						:src="
							require(`../../assets/${
								isRummyOptionSelected
									? 'jeet11-rummy'
									: 'jeet11'
							}.png`)
						"
						alt="Logo"
						class="full-width app-logo"
					/>
				</v-flex>
			</v-layout>
			<v-layout mb-4>
				<v-flex xs12 md4 lg3 class="d-flex">
					<v-text-field
						label="Enter mPin"
						v-model="mPin"
						@keyup.enter="confirmAndPayToUser"
						class="text-field-wrapper pt-4"
						placeholder="* * * *"
						type="password"
					></v-text-field>
				</v-flex>
				<v-flex class="allCenteredChild">
					<v-btn
						outline
						:color="themeInputColor"
						small
						class="btn body-1"
						@click="forgetMpin()"
						>Set/Reset mPin ?</v-btn
					>
				</v-flex>
			</v-layout>
			<v-layout class="d-flex justify-space-between">
				<v-btn
					class="mx-0 mr-4 white--text btn"
					:color="themeInputColor"
					:loading="payingJeet11User"
					@click="confirmAndPayToUser"
					>Confirm</v-btn
				>
				<v-btn class="btn" color="error" outline @click="resetData"
					>Cancel</v-btn
				>
			</v-layout>
		</div>
	</div>
</template>

<script>
import * as utils from "@/utils";
import { FETCH_USER_SETTINGS } from "../../store/action-types";
export default {
	name: "TransferMoney",
	props: [
		"themeInputColor",
		"isLoading",
		"userId",
		"searchingJeet11User",
		"searchedUser",
		"payingJeet11User",
		"forgetMpin",
		"model",
		"jeet11WalletBalance",
		"isRummyOptionSelected",
		"additionalParam",
		"prefetchedAmount",
		"prefetchedRetailerPhoneNo"
	],
	data() {
		return {
			phone: null,
			amount: null,
			mPin: null,
			requiredRule: v => utils._requiredRule(v),
			onlyDigitRule: v => utils._onlyDigitsRule(v, this.prefetchedAmount),
			isValueAllowedRules: v => {
				if (Number(v) < 10 && !this.prefetchedAmount) {
					return "Minimum amount to transfer is Rs 10";
				}
				if (Number(v) > this.jeet11WalletBalance) {
					return "Insufficient Account Balance";
				}
				return true;
			},
			userSettingsData: { userData: {} },
			isUserSettingsError: false,
			isUserSettingsLoading: false
		};
	},
	mounted() {
		this.amount = this.prefetchedAmount;
		this.phone = this.prefetchedRetailerPhoneNo;
	},
	methods: {
		onSearchClick() {
			this.$emit("SEARCH_USER", {
				phone: this.phone + "",
				amount: this.amount + "",
				countryAreaCode: "91"
			});
		},
		resetData() {
			this.phone = this.prefetchedRetailerPhoneNo || null;
			this.amount = this.prefetchedAmount || null;
			this.mPin = null;
			this.resetSearchedUser();
			this.userSettingsData = { userData: {} };
		},
		resetSearchedUser() {
			this.$emit("RESET_SEARCHED_JEET11_USER");
		},
		closeModal() {
			this.resetData();
			this.$emit("CLOSE_MODAL", this.model);
		},
		confirmAndPayToUser() {
			this.$emit("CONFIRM_AND_PAY_TO_JEET11_USER", {
				amount: Math.round(Number(this.amount) * 100) / 100,
				userId: this.userId || this.searchedUser.userId,
				mPin: this.mPin,
				schemeRewardId: this.additionalParam
			});
		},
		fetchUserSettings() {
			this.isUserSettingsLoading = true;
			this.$store
				.dispatch(FETCH_USER_SETTINGS.dispatch, {
					phoneNo: "91" + this.phone,
					p: "isFantasyGenuineUser,isCardGameGenuineUser",
					appName: this.isRummyOptionSelected ? "RUMMY" : "JEET11"
				})
				.then(data => {
					if (!data) this.isUserSettingsError = true;
					this.userSettingsData = data || this.userSettingsData;
				})
				.finally(() => (this.isUserSettingsLoading = false));
		}
	},
	watch: {
		searchedUser(newVal) {
			if (!newVal) {
				this.phone = this.prefetchedRetailerPhoneNo || null;
				this.amount = this.prefetchedAmount || null;
				this.mPin = null;
			}
		},
		prefetchedRetailerPhoneNo(newVal) {
			if (newVal) this.phone = newVal;
		},
		prefetchedAmount(newVal) {
			if (newVal) this.amount = newVal;
		},
		phone(newVal) {
			if (`${newVal}`.length === 10) this.fetchUserSettings();
		}
	}
};
</script>

<style lang="scss" scoped>
.header {
	border-radius: 16px 16px 0 0;
	background-color: #edf0f7;
	color: #233b5d;
	font-weight: 500;
	font-size: 20px;
	line-height: 21px;
	padding: 1em;
	text-align: center;
	letter-spacing: 0.004em;
}
.app-logo {
	width: 250px;
	height: 100px;
	object-fit: contain;
}
</style>
